import { Tabs } from '@mantine/core';
import { BaremetalInstance } from '../../../../../../@types/instance';
import { BaremetalListTable } from '../BaremetalListTable/BaremetalListTable';

interface BaremetalListTabProps {
    baremetals?: BaremetalInstance[];
    isLoading?: boolean;
}

export default function BaremetalListTab({ baremetals, isLoading = false }: BaremetalListTabProps) {
    return (
        <Tabs.Panel value={'baremetal'} className="w-full" style={{ padding: 'none !important' }}>
            <BaremetalListTable baremetals={baremetals} isLoading={isLoading} />
        </Tabs.Panel>
    );
}
